export const BSHHospitalCashProductKey = 'f41f03bc-358a-433e-95f9-75e8404a1e68';
export const BSHPAProductKey = '9ba0d025-ae55-4107-8e79-a1e92d221357';
export const GICPAProductKey = 'a7cf5fe2-d9e2-4cee-b1df-760b99d3113b';
